export const DELETE_TIMER_INFO = "DELETE_TIMER_INFO";
export const UPDATE_TIMER_INFO = "UPDATE_TIMER_INFO";
